import { getArchive, getDatasource, getGlobals } from "storyblok/api"
import { getCategoryBlogArticles } from "storyblok/blog"
import CategoryArchiveSection from "components/Archive/CategoryArchiveSection"
import BlogCard from "components/BlogCard"
import Meta from "components/Meta"
import ArchiveHeader from "components/Archive/ArchiveHeader"
import { getCategoryBlogArticlesApi } from "storyblok/blogApi"
import { CardListSection } from "components/Archive/CardListSection"

export default function BlogArchive({ story, items, categories, meta, perPage, total,currentPage }) {
  return (
    <>
      <Meta info={meta} />
      <main data-pagefind-body>
        <ArchiveHeader story={story?.content} breadcrumbs={[{ text: "Personal Injury Blog", href: "/blog" }]} />
        <CategoryArchiveSection
          categories={categories}
          archiveLink="/blog"
          categoryLinkPrefix="/blog/category/"
          currentTab={{ name: "All", value: "all" }}
          list={<CardListSection
            key="all"
            items={items}
            total={total}
            perPage={perPage}
            currentPage={currentPage}
            columns={4}
            handler={(params) => getCategoryBlogArticlesApi(params)}
            Card={BlogCard} />}
        />
      </main>
    </>
  )
}

export async function getStaticProps({ preview = null }) {
  const globals = await getGlobals()
  const { items, perPage, total, currentPage } = await getCategoryBlogArticles()
  const categories = await getDatasource("blog-categories")
  const story = await getArchive("blog", preview)

  return {
    props: {
      categories,
      perPage,
      total,
      currentPage,
      story: story ?? null,
      meta: story?.content?.twentysixty_seo ?? null,
      globals: globals ?? null,
      items,
      preview,
    },
  }
}
